export default __webpack_public_path__ + "static/media/21_3_1.81e6f92f.png";